import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "pbl_xsj"
};
const _hoisted_2 = {
  class: "wrap"
};
const _hoisted_3 = {
  class: "wrapinner",
  id: "wrapinner"
};
const _hoisted_4 = {
  class: "wrapbox"
};
const _hoisted_5 = {
  class: "videoBox"
};
const _hoisted_6 = {
  class: "nameWarp"
};
const _hoisted_7 = {
  class: "name"
};
const _hoisted_8 = {
  class: "sex"
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  class: "content"
};
const _hoisted_11 = {
  key: 0,
  class: "item"
};
const _hoisted_12 = {
  key: 1,
  class: "item"
};
const _hoisted_13 = {
  key: 2,
  class: "item"
};
const _hoisted_14 = {
  key: 3,
  class: "item"
};
const _hoisted_15 = {
  class: "d_reason_detail"
};
const _hoisted_16 = {
  class: "content"
};
const _hoisted_17 = {
  key: 0,
  class: "item"
};
const _hoisted_18 = {
  key: 1,
  class: "item"
};
const _hoisted_19 = {
  key: 2,
  class: "item"
};
const _hoisted_20 = {
  key: 3,
  class: "item"
};
const _hoisted_21 = {
  class: "d_reason_detail"
};
const _hoisted_22 = {
  class: "nameWarp"
};
const _hoisted_23 = {
  class: "name"
};
const _hoisted_24 = {
  class: "sex"
};
const _hoisted_25 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[8] || (_cache[8] = _createElementVNode("div", {
    class: "topbg"
  }, null, -1)), _cache[9] || (_cache[9] = _createElementVNode("div", {
    class: "bottombg"
  }, null, -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "line",
    style: _normalizeStyle(`top:${$data.lineTop}px; bottom:${$data.lineBottom}px`)
  }, null, 4), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", _hoisted_5, [!(index % 2) ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "videoBoxli",
      style: {
        "padding-left": "30px"
      },
      ref_for: true,
      ref: `videoBoxli_${index}`
    }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(item.sex ? `(${item.sex})` : ''), 1), _createElementVNode("div", {
      class: _normalizeClass(`desc ${item.desc_type} ${item.desc_size <= 18 ? 'desc_2' : ''}`),
      style: _normalizeStyle(`font-size: ${item.desc_size}px`)
    }, [item.desc.split('、').length > 2 ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(item.desc), 1)) : (_openBlock(true), _createElementBlock(_Fragment, {
      key: 1
    }, _renderList(item.desc.split('、'), d => {
      return _openBlock(), _createElementBlock("div", null, _toDisplayString(d), 1);
    }), 256))], 6)]), _createElementVNode("div", {
      class: _normalizeClass({
        'icon': true,
        'icon_r': true,
        'icon_f': !index,
        'icon_end': index == $data.list.length - 1
      })
    }, null, 2), _createElementVNode("div", _hoisted_10, [item.other_name ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_cache[0] || (_cache[0] = _createElementVNode("span", null, "别名：", -1)), _createTextVNode(_toDisplayString(item.other_name), 1)])) : _createCommentVNode("", true), item.place ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_cache[1] || (_cache[1] = _createElementVNode("span", null, "籍贯：", -1)), _createTextVNode(_toDisplayString(item.place), 1)])) : _createCommentVNode("", true), item.year ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_cache[2] || (_cache[2] = _createElementVNode("span", null, "出生年月：", -1)), _createTextVNode(_toDisplayString(item.year), 1)])) : _createCommentVNode("", true), item.d_reason ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_cache[3] || (_cache[3] = _createElementVNode("div", {
      class: "d_reason"
    }, "何时何地牺牲（病故）：", -1)), _createElementVNode("div", _hoisted_15, _toDisplayString(item.d_reason), 1)])) : _createCommentVNode("", true)])], 512)) : (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "videoBoxli",
      style: {
        "padding-left": "-30px"
      },
      ref_for: true,
      ref: `videoBoxli_${index}`
    }, [_createElementVNode("div", _hoisted_16, [item.other_name ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_cache[4] || (_cache[4] = _createElementVNode("span", null, "别名：", -1)), _createTextVNode(_toDisplayString(item.other_name), 1)])) : _createCommentVNode("", true), item.place ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_cache[5] || (_cache[5] = _createElementVNode("span", null, "籍贯：", -1)), _createTextVNode(_toDisplayString(item.place), 1)])) : _createCommentVNode("", true), item.year ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_cache[6] || (_cache[6] = _createElementVNode("span", null, "出生年月：", -1)), _createTextVNode(_toDisplayString(item.year), 1)])) : _createCommentVNode("", true), item.d_reason ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_cache[7] || (_cache[7] = _createElementVNode("div", {
      class: "d_reason"
    }, "何时何地牺牲（病故）：", -1)), _createElementVNode("div", _hoisted_21, _toDisplayString(item.d_reason), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", {
      class: _normalizeClass({
        'icon': true,
        'icon_l': true,
        'icon_f': !index,
        'icon_end': index == $data.list.length - 1
      })
    }, null, 2), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_24, _toDisplayString(item.sex ? `(${item.sex})` : ''), 1), _createElementVNode("div", {
      class: _normalizeClass(`desc ${item.desc_type} ${item.desc_size <= 18 ? 'desc_2' : ''}`),
      style: _normalizeStyle(`font-size: ${item.desc_size}px`)
    }, [item.desc.split('、').length > 2 ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(item.desc), 1)) : (_openBlock(true), _createElementBlock(_Fragment, {
      key: 1
    }, _renderList(item.desc.split('、'), d => {
      return _openBlock(), _createElementBlock("div", null, _toDisplayString(d), 1);
    }), 256))], 6)])], 512))]);
  }), 256))])])])]);
}